(function () {
  angular.module('MktzapApp.Factories')
    .factory('CampaignBroadcastService', CampaignBroadcastService);

  CampaignBroadcastService.$inject = ['$resource'];
  function CampaignBroadcastService ($resource) {
    return $resource('', {}, {
      index: { url: frontUrl + '/campaign-broadcast/index', method: 'GET', isArray: false },
      getMoreInformation: { url: frontUrl + '/campaign-broadcast/get-more-information/:id', method: 'GET', isArray: false },
      save: { url: frontUrl + '/campaign-broadcast/save', method: 'POST', isArray: false },
      getList: { url: frontUrl + '/campaign-management/getList', method: 'GET', isArray: false },
      downloadFile: { url: frontUrl + '/campaign-broadcast/download-file/:id', method: 'GET', isArray: false },
    });
  }
})();
